import React, { useEffect, useState } from 'react'

const Transaction = ({active}) => {
    const [primaryColor, setPrimaryColor] = useState(active ? "#fff" : (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim())
    useEffect(() => {
      setPrimaryColor(active ? "#fff" : (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim())
      
    }, [active])
    return (
        <svg width="22" height="22" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="13.25" stroke={primaryColor} stroke-width="2.5" fill='none' />
            <path d="M21.75 15H15.25C15.1119 15 15 14.8881 15 14.75V9.75" stroke={primaryColor} fill='none' stroke-width="2.5" stroke-linecap="round" />
        </svg>
    )
}

export default Transaction